import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Info } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { FAQS } from "../data/clinic";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-sa-beige/50">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <div className="mb-14">
        <Reveal>
          <SectionLabel testId="faq-label">Good to know</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-espresso mt-6">
            Frequently asked
            <span className="italic text-sa-bronze"> questions</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-sa-espresso/15 border-t-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-xl sm:text-2xl text-sa-espresso hover:no-underline hover:text-sa-bronze text-left py-6">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="font-body text-base text-sa-mocha leading-relaxed pb-6">
                {faq.unconfirmed && (
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-sa-bronze/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-sa-bronze mb-3">
                    <Info className="w-3.5 h-3.5" />
                    Unconfirmed — please verify with us
                  </span>
                )}
                <p>{faq.a}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
